import React, { FC } from 'react'
import { Tag } from '@wmgtech/legato'
import { useReactiveVar } from '@apollo/client'

import { ArtistAvatar } from 'components'
import { currentUserVar } from 'modulesCommon/store'
import useZoneTag from 'modulesCommon/serviceHooks/useZoneTag'
import { MostViewedItemProps } from './MostViewedItem.props'
import { FollowButton } from 'modulesCommon/Follow/containers'

import styles from '../MostViewed/MostViewed.module.scss'
import { Link } from 'react-router-dom'
import { useURLBuilder } from '../../../../shared/hooks'

const MostViewedItem: FC<MostViewedItemProps> = ({ campaign }) => {
  const {getProjectPageUrl} = useURLBuilder()
  const { label, isSpace } = useZoneTag(campaign?.label_id)
  const currentUser = useReactiveVar(currentUserVar)
  const isSameLabel = currentUser?.label_id === `${campaign?.label_id}`

  return (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    <Link className={styles.row} to={getProjectPageUrl(campaign.id!)}>
      <div className={styles.artist}>
        <ArtistAvatar
          className="project-list-item__avatar"
          spotifyId={campaign?.artist?.spotify_id || ''}
          facebookId={campaign?.artist?.facebook_id || ''}
          size="m"
        />
        <div className={styles.campaign}>
          <b>{campaign?.artist?.name}</b>, {campaign.name}
        </div>
      </div>
      <div className={styles.label}>
        {isSpace ? (
          <Tag
            size={'xs'}
            removable={false}
            rounded
            text={label?.alias || ''}
            colorType={isSameLabel ? 'white' : 'dark'}
            containerStyle={isSameLabel ? 'outline' : 'solid'}
            className={styles.tag}
            tooltip
            tooltipText={label?.name || ''}
          />
        ) : null}
      </div>
      <div className={styles.follow}>
        <FollowButton
          projectId={campaign?.id || ''}
          userId={campaign?.owner_id || undefined}
          projectName={`${campaign?.artist?.name}, ${campaign?.name}`}
          disabled={!campaign.active}
        />
      </div>
    </Link>
  )

}

export default MostViewedItem
